import React, { useState, useRef } from "react";
import { 
    Box, 
    TextField, 
    IconButton, 
    Paper,
    Tooltip
} from "@mui/material";
import { 
    Send as SendIcon,
    AttachFile as AttachFileIcon
} from "@mui/icons-material";

const MessageInput = ({ 
    onSendMessage, 
    disabled = false, 
    placeholder = "Type your message... (Enter to send, Shift+Enter for new line)" 
}) => {
    const [message, setMessage] = useState("");
    const [isShiftPressed, setIsShiftPressed] = useState(false);
    const inputRef = useRef(null);

    const handleSendMessage = () => {
        if (message.trim() && !disabled) {
            onSendMessage(message.trim());
            setMessage("");
            inputRef.current?.focus();
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === "Shift") {
            setIsShiftPressed(true);
        }
        
        if (event.key === "Enter" && !isShiftPressed && !disabled) {
            event.preventDefault();
            handleSendMessage();
        }
    };

    const handleKeyUp = (event) => {
        if (event.key === "Shift") {
            setIsShiftPressed(false);
        }
    };

    const handleChange = (event) => {
        setMessage(event.target.value);
    };

    return (
        <Paper 
            elevation={0}
            sx={{ 
                p: 2, 
                borderTop: 1, 
                borderColor: "divider",
                backgroundColor: "background.paper"
            }}
        >
            <Box sx={{ 
                display: "flex", 
                alignItems: "flex-end", 
                gap: 1 
            }}>
                {/* Future: File attachment button */}
                <Tooltip title="Attach file (Coming soon)">
                    <span>
                        <IconButton 
                            disabled={true}
                            size="small"
                            sx={{ mb: 0.5 }}
                        >
                            <AttachFileIcon />
                        </IconButton>
                    </span>
                </Tooltip>

                <TextField
                    ref={inputRef}
                    fullWidth
                    multiline
                    maxRows={4}
                    value={message}
                    onChange={handleChange}
                    onKeyDown={handleKeyPress}
                    onKeyUp={handleKeyUp}
                    disabled={disabled}
                    placeholder={placeholder}
                    variant="outlined"
                    size="small"
                    sx={{
                        "& .MuiOutlinedInput-root": {
                            borderRadius: 3,
                            fontSize: "0.75rem", // 30% smaller font
                            "&:hover fieldset": {
                                borderColor: "primary.main",
                            },
                        },
                        "& .MuiOutlinedInput-input": {
                            fontSize: "0.75rem", // 30% smaller font for input text
                        },
                    }}
                />

                <Tooltip title="Send message">
                    <span>
                        <IconButton 
                            onClick={handleSendMessage}
                            disabled={!message.trim() || disabled}
                            color="primary"
                            sx={{ 
                                mb: 0.5,
                                bgcolor: message.trim() && !disabled ? "primary.main" : "inherit",
                                color: message.trim() && !disabled ? "primary.contrastText" : "inherit",
                                "&:hover": {
                                    bgcolor: message.trim() && !disabled ? "primary.dark" : "inherit",
                                },
                                "&:disabled": {
                                    bgcolor: "inherit",
                                    color: "inherit"
                                }
                            }}
                        >
                            <SendIcon />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>

            {/* Help text */}
            <Box sx={{ mt: 1, textAlign: "center" }}>
                <Box 
                    component="span" 
                    sx={{ 
                        fontSize: "0.65rem", // даже меньше для подсказки
                        color: "text.secondary" 
                    }}
                >
                    {disabled 
                        ? "Please wait..." 
                        : "Press Enter to send • Shift+Enter for new line"
                    }
                </Box>
            </Box>
        </Paper>
    );
};

export default MessageInput; 